import * as React from "react";
import OLMapController from "../components/OLMapController";
import {useEffect, useState} from "react";
import "ol/ol.css"
import Api, {APIs} from "../../../../Api";
import useQuery, {queryParams} from "../../../base/utils/UseQuery";

export const olMapCtrl: OLMapController = new OLMapController();

class DAMaps extends React.PureComponent<any, any> {
    // olMapCtrl: OLMapController;
    constructor(props: any) {
        super(props);
        // this.olMapCtrl = new OLMapController();
        this.state = {
            isMapInit: false
        }
        olMapCtrl.initMap('map')
    }

    componentDidMount() {
        if (!this.state.isMapInit) {
            olMapCtrl.setTarget('map')
            this.setState({isMapInit: true});
        }
        const qParams = ['sector', 'region', 'donor', 'rating']
        const params: any = {}
        qParams.forEach((name) => {
            params[name] = queryParams().get(name)?.replace("/","$") || 'all'
        })
        Api.get(APIs.EAD_PROJECT_LOC, params).then((payload) => {
            if (payload)
                olMapCtrl.addGeoJSONLayer(payload)
        })

    }

    render() {
        return (
            <React.Fragment>
                <div id={"map"} style={{height: "100%", width: "100%"}}/>
            </React.Fragment>
        )
    }
}

export default DAMaps;
